export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевірити адресу"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть адресу"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оберіть блокчейн"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виконати перевірку"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Низький ризик"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Середній ризик"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Високий ризик"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Відсутній у чорному списку"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевірити іншу адресу"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завантажити PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оберіть провайдера"])}
}